import "core-js/stable"
import dompolyfill from './js/modules/dom-polyfill.js';

import "./standalone.scss"
import rnn from '../common/js/rnn'
import init from './js/main'

// Standalone Specific
import attachTogglingOfAccordion from './js/modules/accordion-expanding.js';
import selectTargetTabMenu from './js/modules/tabs-menu.js';
import initCrossDomainLinking from './js/modules/cross-domain-linking.js';

dompolyfill();
window.rnn = rnn

document.addEventListener("DOMContentLoaded", () => {
  init();
  attachTogglingOfAccordion('[data-interaction-accordion]');
  initCrossDomainLinking();
  selectTargetTabMenu();
});

// Hot Module reloading
if(typeof module !== 'undefined' && module.hot){
  module.hot.accept('./js/main', function(){
    console.log('----------- main.js updated -----------')
    main()
  })
  // Capture and Re-insert siteconfig on hot reload
  let siteConfig;
  const _init = rnn.init
  window.rnn.init = cfg => siteConfig = cfg && _init(cfg)
  module.hot.accept('../common/js/rnn', function(){
    console.log('----------- rnn.js updated -----------', siteConfig)
    window.rnn.init(siteConfig)
  })
}
